import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "add-email flex flex-column" }
const _hoisted_2 = { class: "add-email__title flex flex-align-center mb" }
const _hoisted_3 = {
  key: 0,
  class: "icons8-waste mr"
}
const _hoisted_4 = {
  key: 1,
  class: "icons8-mail-account mr"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = {
  key: 0,
  class: "mb"
}
const _hoisted_7 = { class: "add-email__field" }
const _hoisted_8 = { class: "add-email__label" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = { class: "add-email__field" }
const _hoisted_12 = { class: "add-email__label" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "error-message"
}
const _hoisted_15 = { class: "add-email__field" }
const _hoisted_16 = { class: "add-email__label" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "error-message"
}
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { class: "mb" }
const _hoisted_22 = ["checked", "onChange"]
const _hoisted_23 = { class: "label mb" }
const _hoisted_24 = { class: "error-message" }
const _hoisted_25 = {
  key: 4,
  class: "flex flex-justify-end flex-align-center mt"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 5,
  class: "flex flex-justify-end flex-align-center"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_transition_expand = _resolveComponent("transition-expand")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("i", {
      class: "icons8-delete close",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.action === _ctx.notificationActions.Delete)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : (_openBlock(), _createElementBlock("i", _hoisted_4)),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.getTitleText)), 1)
    ]),
    (_ctx.action === _ctx.notificationActions.Create)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.ADD_EMAIL_DESCRIPTION')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('COMMON.NAME')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "add-email__input",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notificationSubscription.name) = $event)),
        disabled: _ctx.action === _ctx.notificationActions.Delete
      }, null, 8, _hoisted_9), [
        [_vModelText, _ctx.notificationSubscription.name]
      ]),
      (_ctx.errorMessage("Name"))
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.errorMessage("Name")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("label", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('COMMON.EMAIL')), 1),
      _withDirectives(_createElementVNode("input", {
        class: "add-email__input",
        type: "email",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.notificationSubscription.email) = $event)),
        disabled: _ctx.action !== _ctx.notificationActions.Create
      }, null, 8, _hoisted_13), [
        [_vModelText, _ctx.notificationSubscription.email]
      ]),
      (_ctx.errorMessage("Email"))
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.errorMessage("Email")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("label", _hoisted_15, [
      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.USER.EMAIL_LANGUAGE')), 1),
      _withDirectives(_createElementVNode("select", {
        class: "add-email__input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.notificationSubscription.language) = $event)),
        disabled: _ctx.action === _ctx.notificationActions.Delete
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localeOptions, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.id,
            value: option.value
          }, _toDisplayString(option.title), 9, _hoisted_18))
        }), 128))
      ], 8, _hoisted_17), [
        [_vModelSelect, _ctx.notificationSubscription.language]
      ]),
      (_ctx.errorMessage("emailLanguage"))
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.errorMessage("emailLanguage")), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.action !== _ctx.notificationActions.Delete)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.OPTIONS')), 1),
          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.OPTIONS_TEXT')), 1),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.OPTIONS_SELECT_DOCUMENTS')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentTypeOptions, (item) => {
            return (_openBlock(), _createElementBlock("label", {
              class: "add-email__checkbox",
              key: item.id
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: _ctx.notificationSubscription.types.includes(item.value),
                onChange: ($event: any) => (_ctx.toggleType(item.value, $event))
              }, null, 40, _hoisted_22),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "add-email__checkbox-box" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.titleKey)), 1)
            ]))
          }), 128))
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('MY_ENVIRONMENT.NOTIFICATION.DELETE_EMAIL_NOTE')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationSubscription.types, (type) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(type), 1))
          }), 256))
        ], 64)),
    (_ctx.errorMessage("Types") && _ctx.notificationSubscription.types.length === 0)
      ? (_openBlock(), _createBlock(_component_transition_expand, {
          key: 3,
          class: "mt-2 mb"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.errorMessage("Types")), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.action === _ctx.notificationActions.Delete)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "add-email__secondary",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 9, _hoisted_26),
          _createElementVNode("button", {
            class: _normalizeClass(["text-button ml-2", { "is-loading": _ctx.isLoading }]),
            type: "button",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.isLoading
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 1),
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "icons8-waste" }, null, -1))
          ], 10, _hoisted_27)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("button", {
            class: _normalizeClass(["text-button", { "is-loading": _ctx.isLoading }]),
            type: "button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideSheet && _ctx.hideSheet(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t('COMMON.CANCEL')), 11, _hoisted_29),
          _createElementVNode("button", {
            class: _normalizeClass(["add-email__primary ml-2", { "is-loading": _ctx.isLoading }]),
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
            disabled: _ctx.isLoading
          }, _toDisplayString(_ctx.$t(_ctx.getSaveButtonText)), 11, _hoisted_30)
        ]))
  ]))
}